import AddTeamUser from "./AddTeaamUser";
import { FiSearch } from "react-icons/fi";
import { MdCancelPresentation } from "react-icons/md";
import { LiaSave } from "react-icons/lia";
import { useEffect, useState } from "react";
import api from "@/components/customAxios/Axios";
import ConfirmButton from "../confirmationPopup";
import { ConfirmDialog } from "primereact/confirmdialog";
import { useLoader } from "@/context/loaderContext";
import { useToast } from "../toast";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import Pagination from "../Pagination";
import Tooltip from "../Tooltip";

const TeamManagement = () => {
	const { setLoading } = useLoader();
	const toast = useToast();
	const [editableRow, setEditableRow] = useState(null);
	const [users, setUsers] = useState([]);
	const [addNewUser, setAddNewUser] = useState(false);
	const [currentRole, setCurrentRole] = useState("");
	const [selectedStatus, setSelectedStatus] = useState("");
	const [searchQuery, setSearchQuery] = useState("");
	const [sortValue, setSortValue] = useState("-last_login");
	const statusOptions = ["User", "Admin"];
	const [totalItems, setTotalItems] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(0);
	// const [itemsPerPage, setItemsPerPage] = useState(10);
	const handleSelect = (status: string) => {
		setSelectedStatus(status === "Clear" ? "" : status);
	};
	const handlePageClick = (page: number) => {
		setCurrentPage(page);
	};
	const getUerLogs = async () => {
		try {
			setLoading(true);
			const response = await api.get("/company_users", {
				params: {
					per_page: 10,
					page: currentPage,
					search_value: searchQuery,
					filter_value: selectedStatus,
					sort_value: sortValue,
				},
			});
			if (response.status === 200) {
				setUsers(response.data.users);
				setTotalPages(response.data.total_pages);
				setTotalItems(response.data.total_count);
			}
		} catch (error: any) {
			toast.error({
				type: "background",
				duration: 3000,
				status: "Error",
				title: "Error fetching team user",
				description: error.response?.data?.error || error.response?.data?.message || "An error occurred.",
				open: true,
			});
		} finally {
			setLoading(false);
		}
	};
	useEffect(() => {
		getUerLogs();
	}, [addNewUser, selectedStatus, sortValue, currentPage]);

	const toggleEditRow = (id: any, role: string) => {
		setCurrentRole(role);
		setEditableRow(id);
	};

	const cancelEditRow = (currentDataIndex: number) => {
		setUsers((prev: any) =>
			prev.map((elem: any, index: number) => {
				if (index === currentDataIndex) {
					return {
						...elem,
						role: currentRole,
					};
				}
				return elem;
			})
		);
		setEditableRow(null);
	};

	const roleChange = (
		event: React.ChangeEvent<HTMLSelectElement>,
		id: number
	) => {
		const newData: any = users.map((item: any) => {
			if (item.id === id) {
				return {
					...item,
					role:
						event.target.value === "Admin"
							? "Talentick_admin"
							: "Talentick_user",
				};
			}
			return item;
		});
		setUsers(newData);
	};
	const deleteJobHandler = async (user: any) => {
		setLoading(true);
		try {
			const resp = await api.delete(`/company_user/${user.id}`);
			if (resp.status === 200) {
				toast.success({
					type: "background",
					duration: 3000,
					status: "Success",
					title: "User Deleted Successfully",
					description: "",
					open: true,
				});
				setAddNewUser((prev) => !prev);
			}
		} catch (err: any) {
			toast.error({
				type: "background",
				duration: 3000,
				status: "Error",
				title: "Error deleting team user",
				description: err.response?.data?.error || err.response?.data?.message || "An error occurred.",
				open: true,
			});
		} finally {
			setLoading(false);
		}
	};

	const updateRole = async (user: any) => {
		setEditableRow(null);

		try {
			setLoading(true);
			const response = await api.put(`/company_user/${user.id} `, {
				user_type: user.role === "Talentick_admin" ? "Admin" : "User",
			});
			if (response.status === 200) {
				toast.success({
					type: "background",
					duration: 3000,
					status: "Success",
					title: "User Updated Successfully",
					description: "",
					open: true,
				});
				getUerLogs();
			}
		} catch (error: any) {
			toast.error({
				type: "background",
				duration: 3000,
				status: "error",
				title: error.response?.data?.error || error.response?.data?.message || "Something Went wrong",
				description: "",
				open: true,
			});
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		// Set a timeout for the search
		const handler = setTimeout(() => {
			getUerLogs();
		}, 2000);

		// Cleanup the timeout if searchQuery changes before 2 seconds
		return () => clearTimeout(handler);
	}, [searchQuery]);

	return (
		<>
			<div className="w-full">
				<ConfirmDialog />
				<div className="bg-white  rounded-xl w-full min-h-[75vh]">
					<div className="flex rounded-lg mb-3 justify-between items-center">
						<label className="block text-lg font-medium text-gray-400">
							Manage Team Members
						</label>
					</div>
					<div className="md:flex justify-between space-y-2 gap-x-1 items-center mb-4 font-body bg-[#F9F9FA] p-1.5 rounded-xl w-full">
						<div className="flex gap-x-3 items-center w-full ">
							<div className="ml-2 relative group">
								{/* <Link to="/add-job" className="shadow-md"> */}
								<AddTeamUser setAddNewUser={setAddNewUser} />
								{/* </Link> */}
								<p className="absolute  w-[100px] text-center  ml-2 px-2 py-1 text-sm bg-black text-white rounded -z-10 group-hover:z-50 transition duration-300 ease-in-out">
									Add a User
								</p>
							</div>
							<div className="relative group ml-2">
								<DropdownMenu>
									<DropdownMenuTrigger asChild>
										<button className="relative flex items-center gap-2 p-2  rounded hover:bg-gray-100 transition">
											{/* Hamburger Icon */}
											<svg
												width="21"
												height="12"
												viewBox="0 0 21 12"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M1 1H20"
													stroke="black"
													strokeWidth="1.5"
													strokeLinecap="round"
												/>
												<path
													d="M5 6H16"
													stroke="black"
													strokeWidth="1.5"
													strokeLinecap="round"
												/>
												<path
													d="M9 11H12"
													stroke="black"
													strokeWidth="1.5"
													strokeLinecap="round"
												/>
											</svg>

											{/* Badge */}
											{selectedStatus && (
												<span className="absolute top-0 right-0 -mt-1 -mr-1 bg-red-500 text-white text-xs font-bold rounded-full w-4 h-4 flex items-center justify-center">
													!
												</span>
											)}
										</button>
									</DropdownMenuTrigger>

									<DropdownMenuContent className="w-56 p-3">
										<DropdownMenuLabel>Role</DropdownMenuLabel>
										<DropdownMenuSeparator />
										{statusOptions.map((status) => (
											<DropdownMenuItem
												key={status}
												onClick={() => handleSelect(status)}
												className={`${selectedStatus === status
													? "bg-gray-100 font-semibold"
													: ""
													} cursor-pointer`}
											>
												{status}
											</DropdownMenuItem>
										))}
										<DropdownMenuSeparator />
										<DropdownMenuItem
											className="cursor-pointer font-bold"
											onClick={() => handleSelect("Clear")}
										>
											Clear
										</DropdownMenuItem>
									</DropdownMenuContent>
								</DropdownMenu>
								<p className="absolute  w-[100px] text-center  ml-2 px-2 py-1 text-sm bg-black text-white rounded -z-10 group-hover:z-50 transition duration-300 ease-in-out">
									Filter
								</p>
							</div>
							<div
								className="ml-2 relative group"
								onClick={() => {
									setSortValue((prev) =>
										prev === "-last_login" ? "last_login" : "-last_login"
									);
								}}
							>
								<svg
									width="18"
									height="16"
									viewBox="0 0 18 16"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M14.3536 0.646447C14.1583 0.451184 13.8417 0.451184 13.6464 0.646447L10.4645 3.82843C10.2692 4.02369 10.2692 4.34027 10.4645 4.53553C10.6597 4.7308 10.9763 4.7308 11.1716 4.53553L14 1.70711L16.8284 4.53553C17.0237 4.7308 17.3403 4.7308 17.5355 4.53553C17.7308 4.34027 17.7308 4.02369 17.5355 3.82843L14.3536 0.646447ZM13.5 1L13.5 15H14.5L14.5 1H13.5Z"
										fill="black"
									/>
									<path
										d="M3.64645 15.3536C3.84171 15.5488 4.15829 15.5488 4.35355 15.3536L7.53553 12.1716C7.7308 11.9763 7.7308 11.6597 7.53553 11.4645C7.34027 11.2692 7.02369 11.2692 6.82843 11.4645L4 14.2929L1.17157 11.4645C0.976311 11.2692 0.659728 11.2692 0.464466 11.4645C0.269204 11.6597 0.269204 11.9763 0.464466 12.1716L3.64645 15.3536ZM4.5 15L4.5 1H3.5L3.5 15H4.5Z"
										fill="black"
									/>
								</svg>

								<p className="absolute  w-[50px] text-center  ml-2 px-2 py-1 text-sm bg-black text-white rounded -z-10 group-hover:z-50 transition duration-300 ease-in-out">
									Sort
								</p>
							</div>
						</div>

						<div className="flex gap-x-1 items-center w-full md:w-auto">
							<div className="relative  ">
								<span className="absolute inset-y-0 left-2 flex items-center text-gray-500">
									<FiSearch size={"18"} />
								</span>
								<input
									type="text"
									value={searchQuery}
									onChange={(e) => setSearchQuery(e.target.value)}
									placeholder="Search here..."
									className="w-full p-1.5 pl-8 border  border-gray-300 rounded-lg f"
								/>
							</div>
						</div>
					</div>

					{/* user log table */}
					<div className="max-h-[750px] min-h-[500px] overflow-y-auto">
						{users.length > 0 ? (
							<table className="w-full min-w-[800px]">
								<thead className="bg-white p-2 sticky top-0 text-gray-500">
									<tr>
										<th className="py-2 px-1 w-[300px]">Email</th>
										<th className="py-2 px-1 w-[300px]">Name</th>
										<th className="py-2 px-1 w-[150px]">Role</th>
										<th className="py-2 px-1 w-[100px] text-center">Action</th>
									</tr>
								</thead>

								<tbody className="bg-white divide-y divide-gray-200 font-normal">
									{users.map((user: any, index: number) => (
										<tr key={user.id} className="">
											<td className="py-4 px-1 font-medium text-[#438437]">
												{user.email}{" "}
												{localStorage.getItem("user") === user.id && (
													<span className="">
														<Tooltip>
															<span>Self </span>
														</Tooltip>
													</span>
												)}
											</td>
											<td className="py-4 px-1 font-medium">
												{user.first_name ? (
													user.first_name + " " + user.last_name
												) : (
													<span className="text-red-500">
														Account setup not done
													</span>
												)}
											</td>

											<td className="py-4 px-1">
												{editableRow === user.id ? (
													<select
														className="py-1 px-3 rounded-full text-xs border bg-white"
														value={
															user.role === "Talentick_admin"
																? "Admin"
																: "User"
														}
														onChange={(e) => roleChange(e, user.id)}
													>
														<option value="Admin">Admin</option>
														<option value="User">User</option>
													</select>
												) : (
													<span
														className={`text-center px-3 py-1.5 rounded-full text-xs font-medium ${user.role === "Talentick_admin"
															? "bg-[#BDE4C3] text-[#438437]"
															: "bg-[#F7C5C5] text-[#CA4F4F]"
															}`}
													>
														{user.role === "Talentick_admin"
															? "Admin"
															: "User"}
													</span>
												)}
											</td>

											<td className="py-4 px-1 text-zinc-600">
												{localStorage.getItem("user") !== user.id && (
													editableRow === user.id ? (
														<div className="flex items-center gap-2 justify-center">
															<div className="relative group">
																<button
																	onClick={() => updateRole(user)}
																	className="hover:scale-110 transition-transform"
																>
																	<LiaSave size={20} />
																</button>
																<p className="absolute right-1  w-[50px] text-center  ml-2 px-2 py-1 text-sm bg-black text-white rounded -z-10 group-hover:z-50 transition duration-300 ease-in-out">
																	Save
																</p>
															</div>
															<div className="relative group">
																<button
																	onClick={() => cancelEditRow(index)}
																	className="text-red-500 hover:scale-110 transition-transform"
																>
																	<MdCancelPresentation size={20} />
																</button>
																<p className="absolute right-1  w-[70px] text-center  ml-2 px-2 py-1 text-sm bg-black text-white rounded -z-10 group-hover:z-50 transition duration-300 ease-in-out">
																	Cancel
																</p>
															</div>
														</div>
													) : (
														<div className="flex items-center gap-2 justify-center">
															<div className="relative group">
																<button
																	onClick={() =>
																		toggleEditRow(user.id, user.role)
																	}
																	className="hover:scale-110 transition-transform"
																>
																	<svg
																		width="20"
																		height="20"
																		viewBox="0 0 23 23"
																		fill="none"
																		xmlns="http://www.w3.org/2000/svg"
																	>
																		<path
																			d="M18.7188 18.0356H4.28115C3.98511 18.0356 3.73462 18.2861 3.73462 18.5822C3.73462 18.8782 3.98511 19.1287 4.28115 19.1287H18.7188C19.0148 19.1287 19.2653 18.8782 19.2653 18.5822C19.2653 18.2861 19.0148 18.0356 18.7188 18.0356ZM3.75739 13.2535L3.73462 15.8267C3.73462 15.9634 3.78016 16.1228 3.89403 16.2139C4.00789 16.305 4.14452 16.3733 4.28115 16.3733L6.85442 16.3505C6.99105 16.3505 7.12769 16.2822 7.24155 16.1911L16.0772 7.35545C16.2821 7.1505 16.2821 6.78614 16.0772 6.58119L13.5267 4.0307C13.3217 3.82575 12.9574 3.82575 12.7524 4.0307L10.9762 5.80693L3.9168 12.8663C3.80294 12.9802 3.75739 13.1168 3.75739 13.2535ZM14.9158 6.96832L13.9138 7.9703L12.1376 6.19406L13.1396 5.19208L14.9158 6.96832ZM4.85046 13.4812L11.3633 6.96832L13.1396 8.74456L6.6267 15.2574H4.85046V13.4812Z"
																			fill="black"
																		/>
																	</svg>
																</button>
																<p className="absolute right-1  w-[50px] text-center  ml-2 px-2 py-1 text-sm bg-black text-white rounded -z-10 group-hover:z-50 transition duration-300 ease-in-out">
																	Edit
																</p>
															</div>
															<div className="relative group">
																<ConfirmButton
																	label=""
																	message="Are you sure you want to deactivate this user?"
																	header=""
																	icon="pi pi-times"
																	acceptClassName="p-button-danger"
																	onConfirm={() => deleteJobHandler(user)}
																/>
																<p className="absolute right-1  w-[70px] text-center  ml-2 px-2 py-1 text-sm bg-black text-white rounded -z-10 group-hover:z-50 transition duration-300 ease-in-out">
																	Delete
																</p>
															</div>
														</div>
													)
												)}
											</td>
										</tr>
									))}
								</tbody>
							</table>
						) : (
							<div className="flex justify-center items-center h-[30vh] text-2xl text-gray-500">
								No Team Member Found
							</div>
						)}
					</div>
				</div>
				<div className="mt-4">
					<Pagination
						dataLength={users.length}
						currentPage={currentPage}
						handlePageClick={handlePageClick}
						totalItems={totalItems}
						totalPages={totalPages}
					/>
				</div>
			</div>
		</>
	);
};

export default TeamManagement;
